import type { PropsWithChildren, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import type { StatusVariant } from './types';
import { classes } from './utils';

export interface StatusScreenProps extends PropsWithChildren {
  className?: string;
  icon: ReactNode;
  message: string;
  title: string;
  variant?: StatusVariant;
}

export default function StatusScreen({
  className,
  icon,
  message,
  title,
  variant = 'success',
  children,
}: StatusScreenProps) {
  return (
    <div className={twMerge(classes.wrapper, className)}>
      <div className={twMerge(classes.tile, classes[variant])}>{icon}</div>
      <div className={classes.title}>{title}</div>
      <div className={classes.message}>{message}</div>
      {children}
    </div>
  );
}
